import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { Button, BUTTON_COLOR } from '../../../../../../atoms'
import { Modal } from '../../../../../../molecules'

interface IModalDeclineBookingProps {
  isOpenModal: boolean
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  ownerDeclinedBooking: {
    callback: () => void
    isLoading: boolean
  }
}

const DeclineBookingModal = ({
  isOpenModal,
  setIsOpenModal,
  ownerDeclinedBooking,
}: IModalDeclineBookingProps) => {
  return (
    <Modal
      title='Refuser la réservation ?'
      isOpen={isOpenModal}
      styleHeader={{
        borderBottom: '1px solid lightgray',
        marginBottom: '20px',
      }}
      closeModal={() => setIsOpenModal(false)}
      footerStyle={{ borderTop: '1px solid lightgray', marginBottom: '20px' }}
      customFooter={
        <div className={s.container}>
          <Button
            className={clsx(s.button, s.backButton)}
            color={BUTTON_COLOR.WHITE}
            onClick={() => setIsOpenModal(false)}
          >
            Revenir en arrière
          </Button>
          <Button
            className={clsx(s.button)}
            color={BUTTON_COLOR.RED}
            onClick={async () => {
              await ownerDeclinedBooking.callback()
              setIsOpenModal(false)
            }}
            loading={ownerDeclinedBooking.isLoading}
          >
            Refuser la réservation
          </Button>
        </div>
      }
    >
      <p>Êtes-vous sûr de vouloir refuser la réservation ?</p>
    </Modal>
  )
}

export default DeclineBookingModal
